import { render, staticRenderFns } from "./register.vue?vue&type=template&id=64c30e67&"
import script from "./register.ts?vue&type=script&lang=ts&"
export * from "./register.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports